// extracted by mini-css-extract-plugin
export var avatar = "_hq-3";
export var avatarContainer = "_hq-2";
export var avatarSpacer = "_hq-5";
export var avatarSpacerContainer = "_hq-4";
export var avatarStackContainer = "_hq-1";
export var bubble = "_hq-0";
export var remainderBubble = "_hq-6";